import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "400",
  height: "400",
  class: "icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M693.787 985.735h43.116c95.232 0 181.733-76.692 181.733-171.386v-38.265h-224.85zM856.927 0H167.073c-47.59 0-86.232 38.373-86.232 85.693v857.195c0 47.374 38.589 81.112 86.232 81.112H612.19V690.392h330.968v-604.7C943.158 38.374 904.569 0 856.926 0m-24.523 523.587h-640.7v-108.76h640.754v108.76zm0-247.915h-640.7V166.966h640.754v108.813h-.054z"
    }, null, -1)
  ])))
}
export default { render: render }